import axios from "axios";
import {
  FETCH_PETSHOPS,
  CREATE_PETSHOP,
  UPDATE_PETSHOP,
  DELETE_PETSHOP,
  FETCH_PETSHOPS_BY_EMAIL,
  SET_CURRENT_PETSHOP,
  ADD_LOGO,
  GET_PETSHOP_BY_DOMAIN,
  CHECK_PETSHOP_N_USER,
  interceptor
} from ".";
import store from "../store";
// import { BASE_URL } from "../utils/helper";

interceptor(axios, store);

export function createPetShop(rt) {
  return {
    type: CREATE_PETSHOP,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/public/pet_shop/`, rt)
  };
}

export function fetchPetShops() {
  return {
    type: FETCH_PETSHOPS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/pet_shop/`)
  };
}

export function updatePetshop(id, data) {
  return {
    type: UPDATE_PETSHOP,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/pet_shop/${id}`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function getDeletable(selected) {
  const ids = { ids: selected };
  return {
    type: DELETE_PETSHOP,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/pet_shop/delete/`, ids)
  };
}

export function fetchPetShopsbyEmail(email) {
  return {
    type: FETCH_PETSHOPS_BY_EMAIL,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/pet_shop/petshopsByEmail/${email}`)
  };
}

export function getCurrentPetShop(title) {
  return {
    type: SET_CURRENT_PETSHOP,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/pet_shop/getCurrentPetshop/${title}`, {
      headers: {
        Authorization: store.getState().cognito.token
      }
    })
  };
}

export function getPetshopByTitle(title) {
  return {
    type: SET_CURRENT_PETSHOP,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/public/pet_shop/getPetshopByTitle/${title}`)
  };
}

export function getPetShopByDomain(domain) {
  return {
    type: GET_PETSHOP_BY_DOMAIN,
    payload: axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/public/pet_shop/getPetshopByDomain/${domain}`
    )
  };
}

export function attachLogo(id, logo) {
  const config = {
    headers: {
      "content-type": undefined,
      Authorization: store.getState().cognito.token,
      PetShopId: store.getState().petShopReducer.currentPetshop.id
    }
  };

  return {
    type: ADD_LOGO,
    payload: axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/core/pet_shop/attachLogo/${id}`,
      logo,
      config
    )
  };
}

export function checkPetshopAndUser(domain, un, email) {
  const data = {
    domain: domain,
    un: un,
    email: email
  };
  return {
    type: CHECK_PETSHOP_N_USER,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/public/pet_shop/checkPetshopnUser`, data)
  };
}
